<template>
  <path fill="currentColor" d="m7.1 29.2.6.3c2.5 1.6 5.4 2.4 8.3 2.5 9 0 16-7.3 16-16C32 7 24.8 0 16 0A16 16 0 0 0 2.5 24.4l.4.6-1.5 5.6 5.7-1.5z"/>
  <path fill="#ffffff" d="M10.8 7H9.5c-.4 0-.8 0-1 .3-1 .7-1.7 1.7-2 3-.5 2 .3 4.3 2 6.7 2.6 3.8 6.5 6.6 11 8 1.4.4 3.1.2 4.4-.6a4 4 0 0 0 1.7-2.5l.2-.9c.1-.3 0-.6-.3-.7l-4-2c-.3-.2-.6-.2-.8.1L19 20.5c0 .1-.3.2-.5.1a13 13 0 0 1-7-6l.1-.5 1.6-1.8c.1-.2.2-.4.1-.7l-1.9-4.3c0-.2-.4-.4-.6-.4"/>
</template>
